// import { createMuiTheme } from '@material-ui/core/styles';
import { createTheme } from "@material-ui/core/styles";

const colors = require("@material-ui/core/colors");

// A custom theme for this app
// const theme = createMuiTheme({
const theme = createTheme({
    spacing: 4,
    palette: {
        primary: {
            light: "#334a92",
            main: "#001d77",
            dark: "#001453",
            contrastText: "#fff",
        },
        secondary: {
            light: "#4792ca",
            main: "#1977bd",
            dark: "#115384",
            contrastText: "#FFF",
        },
        grey: {
            dark: "#212121",
            middle: "#CCCCCC",
            light: "#F5F5F5",
        },
        text: {
            primary: "#000000",
            secondary: "#616161",
        },
        error: {
            main: colors["red"].A400,
        },
        background: {
            default: "#fff",
            paper: "#fff",
        },
    },
    charts: {
        colors: [colors["teal"]["500"], "#bc3908", "#BED600", colors["teal"]["900"], colors["teal"]["900"]],
        gradient: {
            start: colors["teal"]["50"],
            middle: colors["teal"]["100"],
            end: colors["teal"]["200"],
        },
    },
    breakpoints: {
        values: {
            xs: 576,
            sm: 768,
            md: 992,
            lg: 1200,
            xl: 1280,
        },
    },
    typography: {
        htmlFontSize: 16,
        fontFamily: "'Open Sans', sans-serif",
        fontSize: 16,
        // fontWeightLight: 300,
        // fontWeightRegular: 400,
        // fontWeightMedium: 500,
        // fontWeightBold: 700,
        fontWeight: 400,
        h1: {
            fontFamily: "'Open Sans', sans-serif",
            fontWeight: 400,
            fontSize: "6rem",
            lineHeight: 1.167,
            letterSpacing: "-0.01562em",
        },
        h2: {
            fontFamily: "'Open Sans', sans-serif",
            fontWeight: 400,
            fontSize: "3.75rem",
            lineHeight: 1.2,
            letterSpacing: "-0.00833em",
        },
        h3: {
            fontFamily: "'Open Sans', sans-serif",
            fontWeight: 400,
            fontSize: "3rem",
            lineHeight: 1.167,
            letterSpacing: "0em",
        },
        h4: {
            fontFamily: "'Open Sans', sans-serif",
            fontWeight: 400,
            fontSize: "2.125rem",
            lineHeight: 1.5,
            letterSpacing: "0.00735em",
        },
        h5: {
            fontFamily: "'Open Sans', sans-serif",
            fontWeight: 400,
            fontSize: "1.5rem",
            lineHeight: 1.334,
            letterSpacing: "0em",
        },
        h6: {
            fontFamily: "'Open Sans', sans-serif",
            fontWeight: 400,
            fontSize: "1.25rem",
            lineHeight: 1.6,
            letterSpacing: "0.0075em",
        },
        subtitle1: {
            fontFamily: "'Open Sans', sans-serif",
            fontWeight: 400,
            fontSize: "1rem",
            lineHeight: 1.75,
            letterSpacing: "0.00938em",
        },
        subtitle2: {
            fontFamily: "'Open Sans', sans-serif",
            fontWeight: 500,
            fontSize: "0.875rem",
            lineHeight: 1.57,
            letterSpacing: "0.00714em",
        },
        body1: {
            fontFamily: "'Open Sans', sans-serif",
            fontWeight: 400,
            fontSize: "1rem",
            lineHeight: 1.5,
            letterSpacing: "0.00938em",
        },
        body2: {
            fontFamily: "'Open Sans', sans-serif",
            fontWeight: 400,
            fontSize: "0.875rem",
            lineHeight: 1.43,
            letterSpacing: "0.01071em",
        },
        button: {
            fontFamily: "'Open Sans', sans-serif",
            fontWeight: 500,
            fontSize: "0.875rem",
            lineHeight: 1.75,
            letterSpacing: "0.02857em",
            textTransform: "uppercase",
        },
        caption: {
            fontFamily: "'Open Sans', sans-serif",
            fontWeight: 400,
            fontSize: "0.75rem",
            lineHeight: 1.66,
            letterSpacing: "0.03333em",
        },
        overline: {
            fontFamily: "'Open Sans', sans-serif",
            fontWeight: 400,
            fontSize: "0.75rem",
            lineHeight: 2.66,
            letterSpacing: "0.08333em",
            textTransform: "uppercase",
        },
    },
    overrides: {
        MuiCssBaseline: {
            "@global": {
                html: {
                    fontSize: 16,
                    WebkitFontSmoothing: "auto",
                    overflowY: "scroll",
                    minWidth: "100vw",
                    overflowX: "hidden",
                },
                body: {
                    color: "#000",
                    fontFamily: "'Open Sans', sans-serif",
                    padding: "0!important",
                    fontSize: "1rem",
                    fontWeight: 400,
                },
            },
        },
        MuiDivider: {
            root: {
                backgroundColor: "#F5F5F5",
            },
        },
        MuiTooltip: {
            tooltip: {
                color: "#fff",
                backgroundColor: "#616161",
                fontSize: 16,
                fontWeight: 400,
                border: "none",
            },
        },

        MuiButton: {
            root: {
                fontWeight: 400,
                letterSpacing: "0.06em",
                height: 48,
                borderRadius: 26,                
            },
        },
    },
});

export default theme;
